exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer-info[data-v-2c18810c]{width:100%;background-color:#163247}.footer-info #company-info[data-v-2c18810c]{color:#fff;text-align:center}address[data-v-2c18810c]{padding:2em 0;margin-bottom:0!important;font-size:10px;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c18810c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Footer.vue
// module id = 823
// module chunks = 0